/**
 * Self-contained build-time feature flag for PALETTE-DERIVED SEGMENT COLOR
 * (Gordon 2026-07-16, SEGMENT-FILL-DESIGN-MODEL.md).
 *
 * Two things this flag gates, together:
 *   (A) the Segment Palette is auto-generated FROM THE FILL when the fill is an
 *       Image / GIF (reusing the Palette Generator's generateColorsFromImage) or
 *       a Gradient / Pattern (their stops / fg-bg colors), instead of only from
 *       the solid Segment Color; and
 *   (B) the SEGMENT COLOR (wheel slice + open-segment left frame border +
 *       left accent) DEFAULTS to the primary of that Segment Palette, so it
 *       harmonizes with the fill (a green-park image fill -> a green/earth
 *       border, not an arbitrary orange). A manual override is preserved.
 *
 * WHY ITS OWN FILE (mirrors segmentArcFillsFlag.js / segmentFillTitleFlag.js):
 * kept local so this behaviour can be reviewed / merged / rolled out
 * INDEPENDENTLY. Defaults OFF; flipped per environment via
 * REACT_APP_SEGMENT_PALETTE_COLOR.
 *
 * When OFF, everything is BYTE-IDENTICAL to today: the palette is still
 * color-derived, the Segment Color is still the stored settings.color, and no
 * new fields are written.
 *
 * Flag-name collision audit: REACT_APP_SEGMENT_PALETTE_COLOR is a new, unique
 * name — no existing REACT_APP_* var uses the SEGMENT_PALETTE_COLOR token.
 *
 * At merge this can be folded into src/constants/featureFlags.js.
 */
const truthy = (v) => v === "true" || v === "1" || v === true;

export const SEGMENT_PALETTE_COLOR_ENABLED = truthy(
  process.env.REACT_APP_SEGMENT_PALETTE_COLOR
);
